









import Vue, { PropType } from 'vue';
import SectionItemForm, {
  FormDataInterface,
} from '@/containers/cv-section-skill-item/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionSkillItemStoreNew from '@/store/modules/cvSectionSkillItemNew';
import { CvSectionSkill } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SectionItemForm,
  },
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
    section: {
      type: Object as PropType<CvSectionSkill>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title, description, strength }: FormDataInterface) {
      await this.$store.dispatch(
        CvSectionSkillItemStoreNew.CreateCvSectionSkillItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_skill_id: this.section.id,
          },
          body: {
            title,
            description,
            strength,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.created));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
      this.$router.push({ name: 'cv_edit_path' });
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
  },
});
